<template>

    <modal :show="showModal" @closeModal="close">

        <div class="mei__container">

            <img class="mei__img" src="/img/icons/cancel-grey.svg" @click="close">

            <h2 class="mei__title">{{ $t('web_login_google_connect_title_imap') }}</h2>

            <p class="mei__subtitle mt-8">{{ $t('web_login_google_connect_description') }}</p>

            <button class="btn btn-big btn-green mei__btn mt-24" @click="close">{{ $t('web_login_google_connect_cta_imap') }}</button>

        </div>

    </modal>

</template>

<script>

import Modal from '@/components/modal/Modal'

export default {

    name: 'modal-error-imap',

    components: {Modal},

    data() {
        return {
            showModal: false,
            error: ''
        }
    },

    methods: {

        open() {
            this.showModal = true
        },

        close() {
            this.$emit('close')
            this.showModal = false
        }
    }

}

</script>

<style lang="scss" scoped>

.mei {
    &__container {
        position: relative;
        padding: 80px 24px 24px;
        display: flex;
        flex-direction: column;
        align-items: center;
        max-width: 480px;
    }

    &__img {
        width: 32px;
        object-fit: contain;
        position: absolute;
        top: 24px;
        right: 24px;
    }

    &__title {
        font-size: 22px;
        font-weight: 600;
        line-height: 1.09;
        text-align: left;
        color: $charcoal;
    }

    &__subtitle {
        font-size: 17px;
        line-height: 1.41;
        text-align: left;
        color: $charcoal;
    }

    &__btn {
        background-color: $forest;
    }
}


</style>
